import type { CellProps, Column } from 'react-table';

import Tooltip from '../../../../../../../../../../common/Tooltip';
import { pacingTypes } from '../../../../../../../../../../configs';
import { isAllUS } from '../../../../../../../../../../utils/lineItem';
import type { LineItemEntity } from '../../../../../../types';
import MultipleEditBufferCell from './MultipleEditBufferCell';

type GetBufferColumnsArgs = {
  cellClassName: string;
  onSubmitBuffer: (value: number, entityId: string) => void;
  localBufferValues: Record<string, number | null | undefined>;
};

export const getBufferColumns = ({
  cellClassName,
  onSubmitBuffer,
  localBufferValues,
}: GetBufferColumnsArgs): Column<LineItemEntity>[] => [
  {
    Header: 'ID',
    accessor: 'id',
    Cell: ({ cell: { value } }: CellProps<LineItemEntity, string>) => (
      <Tooltip id="multiple-edit-buffer-table-id" message={value}>
        <div className={cellClassName}>{value}</div>
      </Tooltip>
    ),
  },
  {
    Header: 'Name',
    accessor: 'name',
    disableSortBy: true,
    Cell: ({ cell: { value } }: CellProps<LineItemEntity, string>) => (
      <Tooltip id="multiple-edit-buffer-table-name" message={value}>
        <div className={cellClassName}>{value}</div>
      </Tooltip>
    ),
  },
  {
    Header: 'Buffer',
    id: 'buffer',
    Cell: ({ row }: CellProps<LineItemEntity>) => {
      const { id, automatedDeliveryBufferPercent, deliveryBufferPercent, countries, pacingType } = row.original;

      const currentBufferValue = localBufferValues[id] ?? deliveryBufferPercent;
      const isNonUS = !isAllUS(countries);
      const isSOV = pacingType?.key === pacingTypes.SOV.key;

      return (
        <div className={cellClassName}>
          <MultipleEditBufferCell
            id={id}
            automatedDeliveryBufferPercent={automatedDeliveryBufferPercent}
            deliveryBufferPercent={currentBufferValue}
            isToggleOn={row.isSelected}
            onSubmitBuffer={onSubmitBuffer}
            hideAutomated={isNonUS}
            isSOV={isSOV}
          />
        </div>
      );
    },
  },
];
